module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading":{"add-crew-role":"Add Crew Role"}},"es":{"heading":{"add-crew-role":"Añadir función para el personal"}}}')
  delete Component.options._Ctor
}
